module.exports = __webpack_public_path__ + "static/media/earningGraph.1fc54fc4.png";